export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I used to spend too much time figuring out what to teach each week. Having a full library of ready-to-run sessions would make planning much easier and help me walk into class knowing exactly what we’re working on.',
    author: 'Jason M.',
    role: 'Los Angeles, California, USA',
  },
  {
    quote:
      'Managing a large group can be challenging when everyone is waiting for their turn. I look for sessions that keep kids moving, give them clear tasks, and make better use of our training space.',
    author: 'Emily R.',
    role: 'Austin, Texas, USA',
  },
  {
    quote:
      'When I first started coaching parkour, I wasn’t always sure how to structure a full class. A clear session plan with progressions, games, and a warm-up would give me a much better starting point.',
    author: 'Daniel K.',
    role: 'Miami, Florida, USA',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Not every student is ready for the same movement at the same time. I need progressions that give beginners a manageable starting point while allowing more experienced students to keep developing.',
    author: 'Michael B.',
    role: 'San Diego, California, USA',
  },
  {
    quote:
      'The hard part isn’t finding one good drill. It’s building a progression that makes sense week after week. I want lessons that connect, build skills gradually, and give me a clear direction for the season.',
    author: 'Ryan P.',
    role: 'Phoenix, Arizona, USA',
  },
  {
    quote:
      'I noticed the class ran more smoothly when students had clear activities to work on while others took their turns. It gave me a better way to organize the session.',
    author: 'Brandon L.',
    role: 'Chicago, Illinois, USA',
  },
]
